import React, {Component} from "react";
import PropTypes from "prop-types";
import differenceInMinutes from "date-fns/difference_in_minutes";
import EntryModel from "../models/entry";

export default class WorkingTimeSum extends Component {
    static getSum(entries) {
        let sum = 0;
        entries.forEach((entry) => {
            sum += differenceInMinutes(entry.end, entry.begin);
        });

        return sum/60;
    };

    render() {
        return (
            <span className="badge badge-success">Arbeitszeit: {WorkingTimeSum.getSum(this.props.entries)} Stunden</span>
        )
    }
}

WorkingTimeSum.propTypes = {
    entries: PropTypes.arrayOf(PropTypes.instanceOf(EntryModel)).isRequired
};


// WEBPACK FOOTER //
// ./src/components/WorkingTimeSum.js